/* global modForm modUtils */
import { populateTradeFromURL, saveOriginalReferrerCookie } from '../../../helpers';
/**
 * Init Pro Signup form
 */
export function initContractorForm() {
	modForm.opts.formTyCls = 'form--ty';
	modForm.opts.submitData = {};
	modForm.opts.sessionObj = {};
	modForm.opts.landingPage = modUtils.getLandingPage();
	modForm.opts.referrerCookieName = 'original_referrer';
	modForm.opts.referrerCookieExpiration = 60 * 24 * 30;

	saveOriginalReferrerCookie();
	populateTradeFromURL();
}
